import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import './assets/css/all.scss';
import './assets/font/iconfont.css';
import 'ant-design-pro/dist/ant-design-pro.css';
import 'core-js/es'
import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'
import App from './App';
import * as serviceWorker from './serviceWorker';
import zhCN from 'antd/es/locale/zh_CN';
import ConfigProvider from "antd/es/config-provider";
import 'moment/locale/zh-cn';

ReactDOM.render(
    <ConfigProvider locale={zhCN} input={{ autoComplete:"off" }}>
        <App/>
    </ConfigProvider>
    , document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
